<script>
  import { Calendar } from 'element-ui'
  export default {
    name:'ElCalendar',
    extends:Calendar
  }
</script>
